import { useState } from 'react';
import useDebounce from '../../../../hooks/useDebounce/useDebounce';
import LangEnum from '../../../../lang/LangEnum';
import { useInfiniteCollectionsList } from '../../../../services/modules/collections/collections.queries';
import { CATALOG_CREATION_CRITERIA_SEARCH_DEBOUNCE_MS } from '../catalogCreationCriteria.consts';
import { CatalogCreationCriteriaSourcePickerProps } from '../catalogCreationCriteria.types';
import CatalogCreationCriteriaValuePicker from './CatalogCreationCriteriaValuePicker';

const CatalogCreationCollectionCriteriaPicker = ({
  selectedIds,
  optionLabelsById,
  operator,
  onBack,
  onApply,
  onOperatorChange,
  onToggleOption,
}: CatalogCreationCriteriaSourcePickerProps) => {
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, CATALOG_CREATION_CRITERIA_SEARCH_DEBOUNCE_MS);

  const { query } = useInfiniteCollectionsList({ query: debouncedSearch || undefined });

  const options = (query.pagesData ?? []).map(({ id, code, name }) => ({
    id,
    name: name || code,
  }));

  return (
    <CatalogCreationCriteriaValuePicker
      title={LangEnum.GLOBAL_PRODUCT_COLLECTION}
      search={search}
      isLoading={query.isFetching}
      options={options}
      selectedIds={selectedIds}
      optionLabelsById={optionLabelsById}
      operator={operator}
      onBack={onBack}
      onApply={onApply}
      onSearchChange={setSearch}
      onOperatorChange={onOperatorChange}
      onToggleOption={onToggleOption}
      onScrollEnd={query.fetchNextPage}
    />
  );
};

export default CatalogCreationCollectionCriteriaPicker;
